
























































































import { Component, Vue } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class'
import { GET_USER_INFO, GET_USER_TRANSACTIONS, USER_INFO } from "../store/constants";
import { DetailInfo, Transaction } from "../store/types";
import { EMAIL, USER_ID, USERNAME } from "../../auth/store/constants";
import userService from '../services/UserService'

@Component({
    components: {
    },
})
export default class EditProfile extends Vue {
    @Getter(USERNAME) userName!: string;
    @Getter(USER_ID) userId!: string;
    @Getter(EMAIL) email!: string;
    private user: any = {
        username: '',
        email: ''
    };
    private newPassword: string = "";
    mounted() {
        this.user.username = this.userName;
        this.user.email = this.email;
        console.log(this.user)
    }

    async submit() {
        await userService.updateUser(this.userName, this.user)
    }

    async submitUpdatePassword() {
        console.log('submitUpdatePassword', this.newPassword);
        await userService.updatePassword(this.userName, this.newPassword)
    }
}
